import { ReactNode } from "react";
import { cn } from "web-design-system";

// buttons and "Finish setup" link, which are all wider than a figure).
export const GRID_TEMPLATE_CLASS: Record<number, string> = {
  2: "grid-cols-[1fr_7rem]",
  3: "grid-cols-[2fr_1fr_7rem]",
};

export type BreakdownColumn<T> = {
  id: string;
  render: (row: T) => ReactNode;
};

export function getColumnAlignClass(index: number, total: number) {
  if (index === 0) return "text-left justify-self-stretch ml-2";
  if (index === total - 1) return "text-right justify-self-end";
  return "text-center justify-self-center";
}

export function MetricValue({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm text-muted-foreground">{label}</span>
      <div className="text-md font-semibold">{value}</div>
    </div>
  );
}

export function BreakdownTable<T extends { client_id?: number }>({
  rows,
  columns,
  gridClassName,
}: {
  rows: T[];
  columns: BreakdownColumn<T>[];
  gridClassName: string;
}) {
  return (
    <div className={cn("grid gap-y-4 items-center pr-2", gridClassName)}>
      {rows.map((row) =>
        columns.map((column, index) => (
          <div
            key={`${row.client_id}-${column.id}`}
            className={cn(
              "text-sm min-w-0",
              getColumnAlignClass(index, columns.length)
            )}
          >
            {column.render(row)}
          </div>
        ))
      )}
    </div>
  );
}
